import { RestError } from 'services/api-service'

type Messages = { [name: string]: string }
let messages: Messages = {}
let pluralRuleFn
export function loadMessages(msgs: Messages, fn = null) {
  messages = msgs
  pluralRuleFn = fn
}

const msgArgPatterns = []
for (let i = 0; i < 10; i++) {
  msgArgPatterns[i] = new RegExp(`\\{${i}\\}`)
}

/**
 * Get the plural message extension
 */
function getPlural(num) {
  return pluralRuleFn ? pluralRuleFn(num) : (num === 1 ? 'one' : 'other')
}

function msg(key, args = [], pluralNum?: number) {
  const msgKey = pluralNum === undefined ? key : `${key}.${getPlural(pluralNum)}`
  let message = messages[msgKey]
  if (!message && message !== '') {
    return `<?'${key}?>`
  }
  for (let j = 0; j < args.length; j++) {
    message = message.replace(msgArgPatterns[j], args[j])
  }
  return message
}

export function getOfflineOrUnexpectedMsg(e: RestError) {
  if (e.errorCode === 'turnto-offline') {
    return msg('offline.error')
  } else {
    return msg('unexpected.error')
  }
}

// still going to export this function so it can be used outside of a Vue component if needed.
export default msg
